/** @jsx jsx */
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { colors, typography, } from '@argo/principles';

const ErrorContainer = styled.div`
  border-radius: 4px;
  background-color: ${colors.primary.white};
  margin-bottom: 8px;
`;

const ErrorBody = styled.div`
  padding: 19px 16px;
`;

const ErrorTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.black};
  font-weight: ${typography.weight.semiBold};
`;

const ErrorText = styled.div`
  ${typography.types.body}
  padding-top: 16px;
  padding-bottom: 40px;
`;

const GetErrorPanel = () => (
  <ErrorContainer>
    <ErrorBody>
      <ErrorTitle>Info Unavailable</ErrorTitle>
      <ErrorText>Either Kelley Blue Book doesn&apos;t have this information yet or there was an error in retrieving it. Please check back later.</ErrorText>
    </ErrorBody>
  </ErrorContainer>
);

export default GetErrorPanel;
